'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  background: ', ';\n  border-style: ', ';\n  border-width: 1px;\n  border-color: ', ';\n  border-radius: 3px;\n  box-shadow: ', ';\n  ', '\n'], ['\n  width: 100%;\n  background: ', ';\n  border-style: ', ';\n  border-width: 1px;\n  border-color: ', ';\n  border-radius: 3px;\n  box-shadow: ', ';\n  ', '\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles


var CardContainer = _styledComponents2.default.div(_templateObject, _colors.white, function (_ref) {
  var shadow = _ref.shadow;
  return shadow ? 'none' : 'solid';
}, _colors.grey, function (_ref2) {
  var shadow = _ref2.shadow;
  return shadow ? '0 0 20px 0 rgba(0, 0, 0, 0.1)' : 'none';
}, function (_ref3) {
  var visible = _ref3.visible;
  return visible ? '' : 'overflow: hidden;';
});

exports.default = CardContainer;